module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_c('em', [_vm._v("Abbreviations")])])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("ET")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("English Translation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("NICNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("New International Commentary on the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("NTD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Das Neue Testament Deutsch")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("PRE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Realencyclopädie für protestantische Theologie und Kirche")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("RGG")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Religion in Geschichte und Gegenwart")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("TLZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("TZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("ZST")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Zeitschrift für systematische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_c('em', [_vm._v("ZTK")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-head"
  }, [_c('strong', [_vm._v("COMMENTARIES FREQUENTLY CITED")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Althaus, "), _c('em', [_vm._v("Rom")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("P. Althaus, "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Das Neue Testament Deutsch, 6), 6th ed., 1949.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Dibelius, "), _c('em', [_vm._v("Th")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("M. Dibelius, "), _c('em', [_vm._v("An die Thessalonicher")]), _vm._v(" (Handbuch zum Neuen Testament), 3rd ed., 1937.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Dibelius, "), _c('em', [_vm._v("Col")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("M. Dibelius (rev. Greeven), "), _c('em', [_vm._v("An die Kolosser, Epheser, An Philemon")]), _vm._v(" (Handbuch zum Neuen Testament, 12), 3rd ed., 1953.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Greijdanus, "), _c('em', [_vm._v("Rom")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("S. Greijdanus, "), _c('em', [_vm._v("De Brief van den apostel Paulus aan de Gemeente te Rome")]), _vm._v(", I, 1933; II, 1933.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Grosheide, "), _c('em', [_vm._v("1 Cor")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("F. W. Grosheide, "), _c('em', [_vm._v("De eerste brief van den apostel Paulus aan de kerk te Korinthe")]), _vm._v(" (Commentaar op het Nieuwe Testament), 2nd ed., 1957.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Lietzmann, "), _c('em', [_vm._v("Cor")]), _vm._v("., or Lietzmann-Kümmel, "), _c('em', [_vm._v("Cor")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. Lietzmann (rev. W. G. Kümmel), "), _c('em', [_vm._v("An die Korinther")]), _vm._v(" (Handbuch zum Neuen Testament, 9), 4th ed., 1949.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Lietzmann, "), _c('em', [_vm._v("Rom")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. Lietzmann, "), _c('em', [_vm._v("An die Römer")]), _vm._v(" (Handbuch zum Neuen Testament, 8), 4th ed., 1933.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Michel, "), _c('em', [_vm._v("Rom")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("O. Michel, "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Kritisch-exegetischer Kommentar über das Neue Testament, 4), 1955.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Oepke, "), _c('em', [_vm._v("Gal")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("A. Oepke, "), _c('em', [_vm._v("Der Brief des Paulus an die Galater")]), _vm._v(" (Theologischer Handkommentar zum Neuen Testament, 9), 1937.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Ridderbos, "), _c('em', [_vm._v("Col")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. N. Ridderbos, "), _c('em', [_vm._v("Aan de Kolossenzen")]), _vm._v(" (Commentaar op het Nieuwe Testament), 1960.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Ridderbos, "), _c('em', [_vm._v("Rom")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. N. Ridderbos, "), _c('em', [_vm._v("Aan de Romeinen")]), _vm._v(" (Commentaar op het Nieuwe Testament), 1959.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Rigaux, "), _c('em', [_vm._v("Th")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("B. Rigaux, "), _c('em', [_vm._v("Saint Paul: les épitres aux Thessaloniciens")]), _vm._v(" (Études bibliques), 1956.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Schlier, "), _c('em', [_vm._v("Gal")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. Schlier, "), _c('em', [_vm._v("Der Brief an die Galater")]), _vm._v(" (Kritisch-exegetischer Kommentar über das Neue Testament, 7), 10th ed., 1949.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col30"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Wendland, "), _c('em', [_vm._v("Cor")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "col65"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("H. D. Wendland, "), _c('em', [_vm._v("Die Briefe an die Korinther")]), _vm._v(" (Das Neue Testament Deutsch, 7), 5th ed., 1948.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6692bdbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0